import useCheckEmail from "@/domains/auth/hooks/useCheckEmail";
import useSignUp from "@/domains/auth/hooks/useSignUp";
import AuthSignUp from "@/domains/auth/components/sign-up/AuthSignUp.tsx";

export default function AuthSignUpFormContainer() {
  const { error, onSignUp, isPending } = useSignUp();
  const {
    checkEmail,
    error: errorEmailCheck,
    isExistEmail,
    isPending: isChecking,
  } = useCheckEmail();

  return (
    <AuthSignUp
      onSubmit={onSignUp}
      pending={isPending}
      error={error}
      onCheckEmail={checkEmail}
      errorEmailCheck={errorEmailCheck || isExistEmail ? " " : ""}
      isChecking={isChecking}
    />
  );
}
